<template>
<div style="width: 100%;"  v-if="attribute.sorteditAble === false" >
  <div class="item-inner"  >
    <div class="item-title label" style="width: 60%; color: #8e8e93">{{this.attribute.label}}</div>
    <div class="item-input" >
      <input type="text" disabled="disabled"  :value="attribute.valueText" placeholder="选基因" class="open-popup open-goods" data-popup=".popup-gene-only" readonly unselectable="on">
    </div>
  </div>
  <div class="item-inner" >
    <div class="item-title label" style="width: 60%;color: #8e8e93">基因大小</div>
    <div class="item-input">
      <input type="text" :value="curAttrsInGroup[10].valueText" readonly="readonly">
    </div>
  </div>
  <div class="item-inner">
    <div class="item-title label" style="width: 60%;color: #8e8e93">转录本</div>
    <div class="item-input">
      <input type="text" :value="curAttrsInGroup[8].valueText" readonly="readonly">
    </div>
  </div>
  <div class="item-inner">
    <div class="item-title label" style="width: 60%;color: #8e8e93">物种</div>
    <div class="item-input">
      <input type="text" :value="curAttrsInGroup[9].valueText" readonly="readonly">
    </div>
  </div>
</div>
  <div style="width: 100%;"  v-else="" >
    <div class="item-inner"  >
      <div class="item-title label" style="width: 60%;">{{this.attribute.label}}</div>
      <div class="item-input" >
        <input type="text" :value="attribute.valueText" placeholder="选基因" class="open-popup open-goods" data-popup=".popup-gene-only" readonly unselectable="on">
      </div>
    </div>
    <div class="item-inner" >
      <div class="item-title label" style="width: 60%">基因大小</div>
      <div class="item-input">
        <input type="text" :value="curAttrsInGroup[10].valueText" readonly="readonly">
      </div>
    </div>
    <div class="item-inner">
      <div class="item-title label" style="width: 60%;">转录本</div>
      <div class="item-input">
        <input type="text" :value="curAttrsInGroup[8].valueText" readonly="readonly">
      </div>
    </div>
    <div class="item-inner">
      <div class="item-title label" style="width: 60%;">物种</div>
      <div class="item-input">
        <input type="text" :value="curAttrsInGroup[9].valueText" readonly="readonly">
      </div>
    </div>
  </div>

</template>

<script>
//  import $ from 'jquery'
  import Emkt from '../../emkt'
  import {mapState} from 'vuex'
  export default {
    name: 'attr-gene-box',
    data () {
      return {
        attributevalueText: ''
      }
    },
    props: [
      'attribute', 'index', 'curAttrsInGroup', 'customAttrs'
    ],
    mounted () {
    },
    created () {
      this.fetchData()
    },
    computed: {
      options () {
        if (this.attribute.options) {
          return this.attribute.options
        }
        return {}
      },
      attrOptions () {
        let attr = this.curAttrsInGroup
        let resList = []
        for (var i in attr) {
          if (attr[i].customizable === 0 && attr[i].columnName.indexOf('TVInfo.') < 0) {
            resList.push(attr[i])
          }
        }

        return resList
      },
      ...mapState([
        'geneSearchResult'
      ])
    },
    methods: {
      fetchData () {
        /*
        if (this.geneSearchResult['/custOrder']) {
          this.attributevalueText = this.geneSearchResult['/custOrder'].data.symbol
        } else {
          this.attributevalueText = this.attribute.value.symbol
        }
        */
      }
    },
    watch: {
      'geneSearchResult': function (val) {
        let data = val['/custOrder'].data
        let dictionary = Emkt.getEmktMetaData().dictionariesMap
        data['taxName'] = dictionary[61033][data.taxId].dictValue
        if(data.CDSSize === 0 || data.CDSSize === null) {
          this.$weui.alert('您所选择的基因大小为0，请联系售前修改！')
          return
        }
        this.attribute.value = data
        this.attribute.valueText = (data.symbol === undefined) ? data.microNo : data.symbol
        this.customAttrs['GeneInfo.NMID'].value = data.NMID
        this.customAttrs['GeneInfo.NMID'].valueText = data.NMID
        this.customAttrs['GeneInfo.CDSSize'].value = data.CDSSize
        this.customAttrs['GeneInfo.CDSSize'].valueText = data.CDSSize
        this.customAttrs['GeneInfo.symbol'].value = (data.symbol === undefined) ? data.microNo : data.symbol
        this.customAttrs['GeneInfo.symbol'].valueText = (data.symbol === undefined) ? data.microNo : data.symbol
        this.customAttrs['GeneInfo.taxId'].value = data.taxId
        this.customAttrs['GeneInfo.taxId'].valueText = dictionary[61033][data.taxId].dictValue
//        if (this.curAttrsInGroup[7].value === '') {
//          this.curAttrsInGroup[7].value = this.customAttrs['GeneInfo.symbol'].value
//          this.curAttrsInGroup[7].valueText = this.customAttrs['GeneInfo.symbol'].valueText
//        }
//        if (this.curAttrsInGroup[8].value === '') {
//          this.curAttrsInGroup[8].value = this.customAttrs['GeneInfo.NMID'].value
//          this.curAttrsInGroup[8].valueText = this.customAttrs['GeneInfo.NMID'].valueText
//        }
//        if (this.curAttrsInGroup[9].value === '') {
//          this.curAttrsInGroup[9].value = this.customAttrs['GeneInfo.taxId'].value
//          this.curAttrsInGroup[9].valueText = this.customAttrs['GeneInfo.symbol'].valueText
//        }
//        if (this.curAttrsInGroup[10].value === '') {
//          this.curAttrsInGroup[10].value = this.customAttrs['GeneInfo.CDSSize'].value
//          this.curAttrsInGroup[10].valueText = this.customAttrs['GeneInfo.CDSSize'].valueText
//        }
        this.$emit('controlForm', this.index, this.curAttrsInGroup)
      }
    }
  }
</script>

<style scoped>
  input {
    border: 1px solid #ccc;
    outline: 0;
    transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  }
  .error input {
    border-color: rgba(246, 58, 56, .8);
    box-shadow: 0 0 8px rgba(246, 58, 56, .6);
  }
  .item-title label {
    width:60%;
  }
</style>



// WEBPACK FOOTER //
// AttrGeneBox.vue?1dcab992